<template>
  <div id="app-container">
    <loading-bar></loading-bar>
    <transition name="layout" mode="out-in">
      <component :is="layout" v-cloak></component>
    </transition>
  </div>
</template>

<script>
import LoadingBar from '@/components/atoms/LoadingBar';
import DefaultLayout from '@/layouts/default';
import FormLayout from '@/layouts/form';

export default {
  components: {
    DefaultLayout,
    FormLayout,
    LoadingBar
  },
  computed: {
    layout() {
      if (this.$route.meta.layout) {
        return `${this.$route.meta.layout}-layout`;
      }

      return 'default-layout';
    }
  }
};
</script>
